import { makeStyles, tokens } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { FuiButton } from "@/components/fui-control";
import { GhostEmptyState } from "@/components/ghost-empty-state";

const useStyles = makeStyles({
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: 0,
    gap: tokens.spacingVerticalM,
  },
});

/** 없는 플랜과 접근할 수 없는 플랜이 같은 화면이다. 어느 쪽인지 말하지 않는다. */
export function PlanUnavailable() {
  const styles = useStyles();
  const navigate = useNavigate();
  return (
    <div className={styles.page}>
      <GhostEmptyState title="이 플랜을 찾을 수 없습니다" />
      <FuiButton appearance="primary" onClick={() => navigate("/")}>
        플랜 목록으로
      </FuiButton>
    </div>
  );
}
